import {
  createStyles,
  Theme,
  Typography,
  WithStyles,
  withStyles,
} from '@material-ui/core'
import Card from '@material-ui/core/Card/Card'
import CardContent from '@material-ui/core/CardContent/CardContent'
import * as React from 'react'
import { Link } from 'react-router-dom'

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginTop: 18,
      padding: 0,
      width: '100%',
      minHeight: 100,
      height: 100,
      maxHeight: 150,
      shadow: 1,
      '&:hover': {
        opacity: 0.8,
      },
    },
    cardContent: {
      padding: 0,
    },
    title: {
      textTransform: 'uppercase',
      color: theme.palette.primary.main,
      lineHeight: 3,
      fontSize: 13.5,
      paddingLeft: 10,
    },
    content: {
      color: '#fff',
      backgroundColor: theme.palette.primary.main,
      height: 80,
      fontSize: 12,
      minHeight: 80,
      padding: 10,
    },
  })

type Props = WithStyles<typeof styles> & {
  title: string
  subtitle: string
  link: string
}

class TraderSettingsCard extends React.Component<Props> {
  render() {
    const { classes, title, subtitle, link } = this.props

    return (
      <Link to={link} data-cy={'traderSettingCard'}>
        <Card className={classes.root}>
          <CardContent className={classes.cardContent}>
            <Typography
              data-cy={'cardTitle'}
              className={classes.title}
              variant="button"
            >
              {title}
            </Typography>
            <Typography
              variant="caption"
              display="block"
              className={classes.content}
            >
              {subtitle}
            </Typography>
          </CardContent>
        </Card>
      </Link>
    )
  }
}

export default withStyles(styles)(TraderSettingsCard)
